import { AxiosError } from "axios";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  RadialLinearScale,
  Title,
  Tooltip,
} from "chart.js";
import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { RootState } from "../../../app/store";
import { ReactComponent as LeftArrow } from "../../../assets/icons/leftArrow.svg";
import { trendCurvesFilters as dummyFilterType } from "../../../constants/constants";
import { LineGraphData, TrendItem } from "../../../interface/DesignerInterface";
import { formatAndSetDataForTrendCurves } from "../../../utils/trendSidebarGraphUtils/trendCurvesUtils";
import Dropdown from "../Dropdown";
import TrendTable from "./TrendCurveTable";
import TrendCurvesGraph from "./TrendCurvesGraph";

ChartJS.register(
  RadialLinearScale,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  ChartDataLabels,
  ChartDataLabels
);

interface ExpandViewTrendCurvesProps {
  isSidebarOpen?: boolean;
}

const ExpandViewTrendCurves: React.FC<ExpandViewTrendCurvesProps> = ({
  isSidebarOpen,
}) => {
  const navigate = useNavigate();
  const [filterType, setFilterType] = useState("Most Popular");
  const [loading, setLoading] = useState(true);
  const [trendsCurveRawData, setTrendsCurveRawData] = useState<TrendItem[]>([]);

  const [trendsCurveData, setTrendsCurveData] = useState<LineGraphData | null>({
    labels: [],
    datasets: [],
  });

  const user = useSelector((state: RootState) => state.user.userInfo);
  const fetchTrendsCurveData = async () => {
    try {
      setLoading(true);
      await formatAndSetDataForTrendCurves(
        filterType,
        user,
        setTrendsCurveData,
        setTrendsCurveRawData
      );
    } catch (error) {
      console.error("Error Fetching bar graph data", error);
      if ((error as AxiosError)?.response?.status !== 400) {
        toast.error("Error Fetching bar graph data");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrendsCurveData();
  }, [filterType]);
  return (
    <div
      className={`bg-white fixed h-[calc(100vh-80px)] ml-2 ${!isSidebarOpen ? "w-[calc(100vw-265px)]" : "w-[calc(100vw-105px)]"} transition-all duration-500 ease-in-out`}
    >
      <div className="flex flex-row justify-between">
        <div className="flex flex-row ">
          <div>
            <LeftArrow
              className="text-lg ml-4 mt-4 cursor-pointer"
              onClick={() => navigate("/designer-page")}
            />
          </div>
          <div className="transition-all  duration-500 ease-in-out opacity-100 font-semibold max-w-full ml-4 mt-2.5 text-secondary ">
            Trend Curves
          </div>
        </div>
        <div className="mt-2 mr-4 mb-8">
          <div className="text-sm">Filter By</div>
          <div className="w-48">
            <Dropdown
              label={filterType || "Select type"}
              options={dummyFilterType}
              onSelect={option => {
                if (option !== filterType) setFilterType(option);
              }}
            />
          </div>
        </div>
      </div>

      <div className="overflow-y-auto h-[calc(100vh-150px)]">
        <div className="mb-4 mx-auto w-[1150px] ">
          {trendsCurveData && (
            <TrendCurvesGraph
              lineGraphData={trendsCurveData}
              width={1150}
              trendsCurveExpandedView={true}
            />
          )}
        </div>

        <TrendTable trendsCurveRawData={trendsCurveRawData} />
      </div>
    </div>
  );
};

export default ExpandViewTrendCurves;
